import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/Primitives";
import { BookingForm } from "@/components/BookingForm";

export default function BookingEdit() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);
  const resubmit = sp.get("resubmit") === "1";

  useEffect(() => { api.get(`/bookings/${id}`).then((r) => setB(r.data.booking)).catch((e) => toast.error(apiError(e))); }, [id]);
  if (!b) return <div className="text-slate-500">Loading…</div>;
  if (b.locked) return <div className="panel p-6 text-rose-300" data-testid="edit-locked-msg">This booking is locked ({b.charge_status}) and can no longer be edited.</div>;

  async function submit(payload) {
    setBusy(true);
    try {
      await api.patch(`/bookings/${id}`, { ...payload, resubmit });
      toast.success(resubmit ? "Resubmitted to Payment Desk" : "Booking updated");
      nav(`/bookings/${id}`);
    } catch (e) { toast.error(apiError(e, "Update failed")); }
    finally { setBusy(false); }
  }

  return (
    <div data-testid="booking-edit-page">
      <PageHeader eyebrow={<span className="font-mono">{b.booking_ref}</span>} title={resubmit ? "Fix & Resubmit" : "Edit Booking"}>
        <StatusBadge status={b.charge_status} />
      </PageHeader>
      <BookingForm mode="edit" initial={{ ...b, resubmit }} onSubmit={submit} submitting={busy} />
    </div>
  );
}
